import { render, staticRenderFns } from "./UsersSelectableModal.vue?vue&type=template&id=36c97bd8&"
import script from "./UsersSelectableModal.vue?vue&type=script&lang=js&"
export * from "./UsersSelectableModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports